import * as React from "react";
import _ from "lodash";

export default function Bubble(props) {
  return (
    <>
      <div className="bubbles">
        {_.times(30, (i) => (
          <div key={i} className="bubble"></div>
        ))}
      </div>
    </>
  );
}
